import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { getArtworkUrl } from '../utils/Contentful';

const Author = styled.div`
  margin-top: calc(var(--fr) * 2);
  margin-bottom: calc(var(--fr) * 2);
  text-align: left;
  display: flex;
  align-items: center;

  .avatar {
    border-radius: 50%;
    height: calc(var(--fr) * 2);
    overflow: hidden;
    width: calc(var(--fr) * 2);
    margin-right: calc(var(--fr) * 0.5);
  }

  .name {
    font-weight: 500;
    font-size: var(--fs-base);
    color: var(--c-manatee);
  }
`;

const ArticleAuthor = ({ author }) => {
  if (!author.fullName) {
    return null;
  }

  return (
    <Author>
      {author.image && <img src={getArtworkUrl(author.image)} alt="" className="avatar" />}
      <span className="name">{author.fullName}</span>
    </Author>
  );
};

ArticleAuthor.propTypes = {
  author: PropTypes.object.isRequired,
};

export default ArticleAuthor;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/article/ArticleAuthor.js